// extracted by mini-css-extract-plugin
module.exports = {"board":"ChangePassword_board_9qq1u","header":"ChangePassword_header_13VVG","title":"ChangePassword_title_3E-Vr"};